<template>
  <section>
    <resource
      title="Ändern"
      resource="priceLevel"
      resourceName="Preisstufe"
      :original="original"
      :attributes="[
        {
          name: 'at_amount',
          label: 'Ab',
          type: 'Number'
        },
        {
          name: 'bonus',
          label: 'Bonus',
          type: 'Number'
        }
      ]"
    >
      <div slot="title">
        <h4>Preisstufe bearbeiten</h4>
      </div>
    </resource>
  </section>
</template>

<script lang="babel">
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('priceLevel/read', [
      {
        name: 'where',
        attributes: {
          id : Number(to.params.id),
        }
      },
    ]).then(() => {
      next();
    });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['priceLevel/find'](this.id);
    },
    updateUrl() {
      return this.original !== undefined ? this.original.update_url : "";
    }
  }
}
</script>
